@if (cta?.targetUrl) {
  <div tabindex="0" [className]="cta?.rowClass" (agInteract)="targetLink(cta.targetUrl)">
    <div
      class="link-one cursor-pointer"
      alt=""
      [ngStyle]="getCTAstyles()"
      [title]="cta?.imgTitle && cta?.imgTitle !== '' ? $safeNavigationMigration(cta?.imgTitle) : ''"
      [tabindex]="cta.imgUrl ? 0 : -1"
    >
      <div class="border-line">
        @if (cta.title) {
          <h3 [ngStyle]="{ background: cta.titleBack ? cta.titleBack : titleBack }">
            {{ cta?.title }}
          </h3>
        }
        @if (cta.paragraph) {
          <p [ngStyle]="{ background: cta.paraBack ? cta.paraBack : paraBack }">
            {{ cta?.paragraph }}
          </p>
        }
        @if (cta.btnShow) {
          <button
            role="button"
            type="button"
            tabindex="0"
            [attr.aria-label]="cta.btnLabel"
            [ngClass]="cta.btnClass ? cta.btnClass : 'btn btn-primary'"
            (focus)="onBtnFocus($event)"
            (focusout)="onBtnFocusOut($event)"
          >
            {{ cta.btnLabel }}
          </button>
        }
      </div>
    </div>
  </div>
}
<!-- IF NO ANCHOR LINK -->
@if (!cta.targetUrl) {
  <div [className]="cta.rowClass">
    <div
      class="link-one"
      alt=""
      [ngStyle]="getCTAstyles()"
      [title]="cta?.imgTitle && cta?.imgTitle !== '' ? $safeNavigationMigration(cta?.imgTitle) : ''"
    >
      <div class="border-line">
        @if (cta.title) {
          <h3 [ngStyle]="{ background: cta.titleBack ? cta.titleBack : titleBack }">
            {{ cta?.title }}
          </h3>
        }
        @if (cta.paragraph) {
          <p [ngStyle]="{ background: cta.paraBack ? cta.paraBack : paraBack }">
            {{ cta?.paragraph }}
          </p>
        }
        @if (cta.btnShow) {
          <button
            role="button"
            type="button"
            [attr.aria-label]="cta.btnLabel"
            [ngClass]="cta.btnClass ? cta.btnClass : btnClass"
            (focus)="onBtnFocus($event)"
            (focusout)="onBtnFocusOut($event)"
          >
            {{ cta.btnLabel }}
          </button>
        }
      </div>
    </div>
  </div>
}
